export default __webpack_public_path__ + "static/media/ftmanimalzlp.a1e63560.png";